
import Awards from "../employee-recognition/Awards";

export { Page }

function Page() {
  return <Awards />;
}
